import { render, staticRenderFns } from "./staffulldetailsNew.vue?vue&type=template&id=18375b1a"
import script from "./staffulldetailsNew.vue?vue&type=script&lang=js"
export * from "./staffulldetailsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports